/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IPricesV4 } from './PricesV4';

export interface IHouseOfferHistoryV4 {
  /** Идентификатор объявления **/
  id: number;
  /** Относительная ссылка на оффер **/
  link?: THouseOfferHistoryV4_Link;
  /** Текстовый заголовок для квартиры, включающий площадь, комнатность и этаж **/
  title: string;
  prices: IPricesV4;
  /** Строка срока показа объявления **/
  exposition: string;
  /** Статус объявления **/
  status: EStatus;
  /** Дата публикации **/
  dateStart: string;
  /** Дата снятия объекта **/
  dateEnd?: THouseOfferHistoryV4_DateEnd;
  /** Фото объявления **/
  previewPhoto?: THouseOfferHistoryV4_PreviewPhoto;
  /** Строка со временем в пути до родительского дома **/
  walkWayMinutes?: THouseOfferHistoryV4_WalkWayMinutes;
}

export type THouseOfferHistoryV4_Link = null | string;

export enum EStatus {
  /** Опубликовано **/
  'Published' = 'published',
  /** Снято с публикации **/
  'Deactivated' = 'deactivated',
}
export type THouseOfferHistoryV4_DateEnd = null | string;

export type THouseOfferHistoryV4_PreviewPhoto = null | string;

export type THouseOfferHistoryV4_WalkWayMinutes = null | string;
